import { FASTElement, attr, css, customElement, observable } from "@microsoft/fast-element";
import template from "./template.js";
import styles from "./styles.js";

@customElement({
  name: 'hero-card',
  template,
  styles
})
export class HeroCard extends FASTElement {
  @attr({ attribute: 'img-src' })
  public imgSrc!: string;

  @attr({ attribute: 'img-alt' })
  public imgAlt!: string;
}